import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchCmsBusinessMaturity } from './branches/BranchCmsBusinessMaturity';
import { BranchIntegratedAppCookieless } from './branches/BranchIntegratedAppCookieless';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
import { BranchAddHubletExistingUser } from './branches/BranchAddHubletStep';
import { BranchAddHubletNewUser } from './branches/BranchAddHubletNewUser';
import { BranchACQ0173 } from './branches/BranchACQ0173';
import { BranchBreezeCompanyInfo } from './branches/BranchBreezeCompanyInfo';
import { BranchACQ0175VariantB } from './branches/BranchACQ0175VariantB';
import { BranchACQ0175VariantA } from './branches/BranchACQ0175VariantA';
import { BranchACQ0177VariantA } from './branches/BranchACQ0177VariantA';
const DefaultBranches = [BranchQuestionFallback];
let FlowBranches;
export const getFlowBranches = () => {
  if (typeof FlowBranches === 'undefined') {
    const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber, BranchAddHubletExistingUser, BranchAddHubletNewUser];
    FlowBranches = {
      [Flow.Crm]: [...softwareSignupBranches, BranchACQ0173, BranchBreezeCompanyInfo, BranchACQ0175VariantB, BranchACQ0175VariantA, BranchACQ0177VariantA],
      [Flow.Marketing]: [...softwareSignupBranches, BranchACQ0173, BranchBreezeCompanyInfo, BranchACQ0175VariantB, BranchACQ0175VariantA, BranchACQ0177VariantA],
      [Flow.Sales]: [...softwareSignupBranches, ProductSetupUIBranch, BranchACQ0173, BranchBreezeCompanyInfo, BranchACQ0175VariantB, BranchACQ0175VariantA, BranchACQ0177VariantA],
      [Flow.Service]: [...softwareSignupBranches, BranchACQ0173, BranchBreezeCompanyInfo, BranchACQ0175VariantB, BranchACQ0175VariantA, BranchACQ0177VariantA],
      [Flow.CmsFree]: [BranchCmsBusinessMaturity, ...softwareSignupBranches],
      [Flow.Integrations]: [BranchIntegratedAppCookieless, BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.ClassroomTraining]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.AssetProvider]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.SolutionsProvider]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.FbCrm]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.HubspotForStartups]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.HubSpotPartners]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.Microapp]: [BranchCmsBusinessMaturity, BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.Commerce]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.Academy]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.AcademyEmbedded]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.DirectoryListing]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.Developers]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.CmsDevelopers]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.Trial]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.Purchase]: [BranchAddHubletExistingUser, BranchAddHubletNewUser]
    };
  }
  return FlowBranches[getFlowKey()] || DefaultBranches;
};